// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toc-wide-variant":"_29P11o","bottom":"A481H0","hideDesktop":"_2QWaeF","hideNotDesktop":"_24_3Y-"};